// Strings for the app shell: sidebar, mini timer, command palette, shortcuts.
import { registerMessages } from '../i18n.svelte';

registerMessages({
  nl: {
    'timer.status_running': 'Loopt',
    'timer.status_break': 'Pauze',
    'timer.status_stopped': 'Gestopt',
    'timer.start': 'Start timer',
    'timer.pause': 'Pauze',
    'timer.resume': 'Hervatten',
    'timer.stop': 'Stoppen',
    'timer.continue': 'Verder',
    'timer.save': 'Opslaan',
    'timer.saved': 'Registratie opgeslagen',
    'timer.discard': 'Weggooien',

    'palette.placeholder': 'Zoek een pagina, klant of actie…',
    'palette.pages': 'Pagina’s',
    'palette.actions': 'Acties',
    'palette.clients': 'Klanten',
    'palette.settings': 'Instellingen',
    'palette.start_for': 'Start timer voor {name}',
    'palette.toggle_theme': 'Wissel licht/donker thema',
    'palette.no_results': 'Niets gevonden',
    'palette.hint': '↑↓ kiezen · ↵ openen · esc sluiten',

    'shortcuts.title': 'Sneltoetsen',
    'shortcuts.palette': 'Zoeken / command palette',
    'shortcuts.new_entry': 'Nieuwe registratie',
    'shortcuts.timer_toggle': 'Timer starten / stoppen',
    'shortcuts.goto_dashboard': 'Dashboard',
    'shortcuts.goto_timer': 'Timer',
    'shortcuts.goto_entries': 'Registraties',
    'shortcuts.goto_clients': 'Klanten',
    'shortcuts.goto_reports': 'Rapporten',
    'shortcuts.goto_settings': 'Instellingen',
    'shortcuts.help': 'Deze lijst tonen',

    'shell.clients_all': 'Alle klanten',
    'shell.no_clients': 'Nog geen klanten',
    'shell.theme_light': 'Licht',
    'shell.theme_dark': 'Donker',
    'shell.theme_system': 'Systeem',
    'shell.theme': 'Thema',
    'shell.shortcuts': 'Sneltoetsen',
    'shell.not_found_title': 'Pagina niet gevonden',
    'shell.not_found_text': 'Deze pagina bestaat niet (meer).',
    'shell.to_dashboard': 'Naar het dashboard'
  },
  en: {
    'timer.status_running': 'Running',
    'timer.status_break': 'On a break',
    'timer.status_stopped': 'Stopped',
    'timer.start': 'Start timer',
    'timer.pause': 'Break',
    'timer.resume': 'Resume',
    'timer.stop': 'Stop',
    'timer.continue': 'Continue',
    'timer.save': 'Save',
    'timer.saved': 'Time entry saved',
    'timer.discard': 'Discard',

    'palette.placeholder': 'Search a page, client or action…',
    'palette.pages': 'Pages',
    'palette.actions': 'Actions',
    'palette.clients': 'Clients',
    'palette.settings': 'Settings',
    'palette.start_for': 'Start timer for {name}',
    'palette.toggle_theme': 'Toggle light/dark theme',
    'palette.no_results': 'Nothing found',
    'palette.hint': '↑↓ select · ↵ open · esc close',

    'shortcuts.title': 'Keyboard shortcuts',
    'shortcuts.palette': 'Search / command palette',
    'shortcuts.new_entry': 'New time entry',
    'shortcuts.timer_toggle': 'Start / stop the timer',
    'shortcuts.goto_dashboard': 'Dashboard',
    'shortcuts.goto_timer': 'Timer',
    'shortcuts.goto_entries': 'Time entries',
    'shortcuts.goto_clients': 'Clients',
    'shortcuts.goto_reports': 'Reports',
    'shortcuts.goto_settings': 'Settings',
    'shortcuts.help': 'Show this list',

    'shell.clients_all': 'All clients',
    'shell.no_clients': 'No clients yet',
    'shell.theme_light': 'Light',
    'shell.theme_dark': 'Dark',
    'shell.theme_system': 'System',
    'shell.theme': 'Theme',
    'shell.shortcuts': 'Keyboard shortcuts',
    'shell.not_found_title': 'Page not found',
    'shell.not_found_text': 'This page does not exist (anymore).',
    'shell.to_dashboard': 'Go to the dashboard'
  }
});
